/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import "../../../css/style.css";

//아이디 찾기
const EditPWDOK = ({varShowPopupWin,onClosePopupHandler}) => {

  return (
    <div id="modal" className={varShowPopupWin?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm">
        <div className="layer__pop__head mb15">
          <div className="layer__pop__title">비밀번호가 변경되었습니다.</div>
          <div className="layer__pop__close" onClick={e=>onClosePopupHandler(e,0)}></div>
        </div>
        <div className="layer__pop__body mb40">
          <div className="layer__pop__text">
            변경된 비밀번호로 로그인해주세요.
          </div>
        </div>
        <div className="layer__pop__bottom">
          <div className="layer__pop__btn" onClick={e=>onClosePopupHandler(e,1)}>로그인하기</div>
        </div>
      </div>
    </div>
  );
}
export default EditPWDOK;